
import React, { useState, useEffect, useRef } from 'react';
import '../itemPage.css';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { convertColumnNameToPascalCase, handleDeleteRowCommon, useCartUtils } from '../ItemPageShared/ItemUtils';
import { useCart } from '../ItemPageShared/itemContext';
import { toast } from 'react-toastify';
import { GetItembyPasting } from '../../APIServices/ItemPageService/ItemPageThunk';
const TableView = React.memo(({
    handleItemInputChange,
    searchTerms,
    searchItem,
    isDropdownOpen,
    totalCount,
    setDueDate,
    DueDate,
    setRemarks,
    handleItemSelect,
    setCallInProgress,
    callInProgress,
    setInputValue,
    setRows,
    rows,
    handleDeleteRow
}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const { additionalData } = location.state || {};
    const { loading, error, GetCartItm, ItemDetailsbyPasting } = useSelector((state) => state.itemPage);
    const [rowCount, setRowCount] = useState(0);
    const dropdownRef = useRef(null);
    const user = sessionStorage.getItem('user');
    const encrpt = JSON.parse(user);
    // const rowsInitialized = useRef(false);
    const excludedColumns = ['onHand', 'itmsGrpCod', 'onOrder', 'isCommited'];
    const columns = ['item_Code', 'item_Name', 'quantity', 'uom', 'uom_multiple', 'price', 'discount_Percentage', 'price_After_Discount', 'Total']
    // const [pendingAutoSelect, setPendingAutoSelect] = useState(null);
    const [isOtherCustomer, setIsOtherCustomer] = useState(false);
    const LeadDetails = sessionStorage.getItem('CustomerDetails');
    const { handleQuantityChange } = useCartUtils();
    const { cart, setCartItems, setGrandTotal,
        searchResults
    } = useCart();
    useEffect(() => {
        if (LeadDetails) {
            const lead = JSON.parse(LeadDetails);
            if (lead.CheckBox === 'checked') {
                setIsOtherCustomer(true);
            }
        }
    }, []);

    useEffect(() => {
        if (GetCartItm?.length > 0) {
            setCartItems(GetCartItm);
            GetCartItm.forEach(() => handleAddRowClick());
            setRemarks(GetCartItm[0]?.Remarks || "");
        }
    }, [GetCartItm, additionalData]);



    useEffect(() => {
        const handleBeforeUnload = (event) => {
            const message = "Are you sure you want to leave this pages?";
            event.returnValue = message;
            return message;
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        if (!rows || rows.length === 0) {
            setRows([{}]);
        }
    }, []);


    const addRows = (count) => {
        setRows(prevRows => {
            const newRows = [...prevRows];
            for (let i = 0; i < count; i++) {
                newRows.push({}); // Add empty row objects
            }
            return newRows;
        });
    };

    // Handle the "Add Row" button click
    const handleAddRowClick = () => {
        addRows(rowCount + 1); // Add rows based on rowCount state
        setRowCount(0);
    };

    const updateGrandTotal = (cart) => {
        const grandTotal = cart
            .reduce((sum, item) => sum + parseFloat(item.total || 0), 0)
            .toFixed(2);  // Round the total to two decimal places

        setGrandTotal(grandTotal);  // Update the grand total state
    };



    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
        if (bottom && !loading.GetItmBySearch && searchResults.length < totalCount) {
            const nextPage = Math.floor(searchResults.length / 100) + 1;
            const firstRowKey = Object.keys(searchTerms)[0]; // Get the only/dynamic row key
            const itemCode = searchTerms?.[firstRowKey]?.["Item Code"] ||
                searchTerms?.[firstRowKey]?.["Item Name"] ||
                "";

            handleItemInputChange(itemCode, nextPage, null, null)
        }
    };

    useEffect(() => {
        // Ensure rows are populated with data from cartItems or empty if no data
        const updatedRows = rows && rows.map((_, index) => ({
            ...cart[index], // Populate rows with data from cartItems
        }));
        setRows(updatedRows);
        if (Object.values(searchTerms).length > 2) {
            const currentSearchTerm = searchTerms[Object.keys(searchTerms)[0]]; // Getting the current search term
        }
    }, [cart, searchTerms]);

    ;
    useEffect(() => {
        if (cart && cart.length > 0) {
            setRows(Array.from({ length: cart.length }, () => ({})));
        }
    }, [cart]);
    useEffect(() => {
        if (!cart || cart.length === 0) return;
        const lastRow = cart[cart.length - 1];
        if (!lastRow) return;
        const requiredFields = ['item_Code', 'item_Name', 'quantity'];
        const isLastRowFilled = requiredFields.every(field => {
            const value = lastRow[field];
            return value !== undefined && value !== null && value !== '';
        });
        if (isLastRowFilled) {
            handleAddRowClick();
        }
    }, [cart]);

    const handleCheckBox = () => {
        setIsOtherCustomer(!isOtherCustomer); // Toggle the checkbox state
        setInputValue((prevValue) => {
            const updatedValue = {
                ...prevValue,
                CheckBox: isOtherCustomer ? '' : 'checked', // Set or reset value based on checkbox state
            }
            sessionStorage.setItem('CustomerDetails', JSON.stringify(updatedValue));

            return updatedValue;
        });
    };
    // const handlePaste = (e, rowIndex) => {
    //     e.preventDefault();
    //     const paste = e.clipboardData.getData("text/plain");
    //     const lines = paste.trim().split(/\r?\n/);
    //     const errors = [];
    //     setCartItems((prevRows) => {
    //       const updatedRows = [...prevRows];
    //       let hasError = false; 
    //       lines.forEach((line, index) => {
    //         const values = line.trim().split(/\t+|\s{2,}/); 
    //         const [itemCodeRaw, itemNameRaw, quantityRaw] = values;
    //         const itemCode = itemCodeRaw?.trim();
    //         const itemName = itemNameRaw?.trim();
    //         const quantity = quantityRaw?.trim();
    //         console.log("quantity",quantity);
    //         if (!itemCode || !itemName) {
    //             toast.error(`Line ${index + 1}: Missing Value`);
    //             hasError = true;
    //             return;
    //         }
    //         const targetRow = rowIndex + index;
    //         if (!updatedRows[targetRow]) updatedRows[targetRow] = {};
    //         const existingQuantity = updatedRows[targetRow].quantity;
    //         console.log("e,xistingQuantity",existingQuantity);
    //         const Quantity = existingQuantity ? quantity : '';
    //         updatedRows[targetRow] = {
    //           ...updatedRows[targetRow],
    //           item_Code: itemCode,
    //           item_Name: itemName,
    //           quantity: Quantity,
    //         };
    //       });

    //       if (!hasError&& updatedRows.length > 0) {
    //         const itemCodesFormatted = updatedRows
    //           .filter(item => item.item_Code)
    //           .map(item => `'${item.item_Code}'`)
    //           .join(',');

    //         setCallInProgress(prev => ({ ...prev, getPasteItems: true }));
    //         dispatch(GetItembyPasting({ ItemCodes: itemCodesFormatted }));
    //       }

    //       return updatedRows;
    //     });
    //   };

    // const handlePaste = (e, rowIndex) => {
    //     e.preventDefault();
    //     const paste = e.clipboardData.getData("text/plain");
    //     const lines = paste.trim().split(/\r?\n/);
    //     const errors = [];

    //     const isNullOrEmpty = (value) => {
    //         return !value || value.trim() === "";
    //     };
    //     setCartItems((prevRows) => {
    //         const updatedRows = [...prevRows];
    //         lines.forEach((line, index) => {
    //             const values = line.trim().split(/\t+|\s{2,}/); // Tabs or 2+ spaces
    //             const [itemCodeRaw, itemNameRaw, quantityRaw] = values;
    //             const itemCode = itemCodeRaw?.trim();
    //             const itemName = itemNameRaw?.trim();
    //             const quantity = quantityRaw?.trim();
    //             if (isNullOrEmpty(itemCode) || isNullOrEmpty(itemName)) {
    //                 toast.error(`Line ${index + 1}:Missing Value`);
    //                 return;
    //             }
    //             const targetRow = rowIndex + index;
    //             if (!updatedRows[targetRow]) updatedRows[targetRow] = {};
    //             const existingQuantity = quantity;
    //             const Quantity = existingQuantity ? quantity : 1;
    //             updatedRows[targetRow] = {
    //                 ...updatedRows[targetRow],
    //                 item_Code: itemCode,
    //                 item_Name: itemName,
    //                 quantity: Quantity,
    //             };
    //         });
    //         if (updatedRows.length > 0) {
    //             const itemCodesFormatted = updatedRows
    //                 .filter(item => item.item_Code)
    //                 .map(item => `'${item.item_Code}'`)
    //                 .join(',');
    //             setCallInProgress(prev => ({ ...prev, getPasteItems: true }));
    //             dispatch(GetItembyPasting({ ItemCodes: itemCodesFormatted }));
    //         }
    //         return updatedRows;
    //     });
    // };
    // const handlePaste = (e, rowIndex) => {
    //     e.preventDefault();
    //     const paste = e.clipboardData.getData("text/plain");
    //     const lines = paste.trim().split(/\r?\n/);
    //     const isNullOrEmpty = (value) => !value || value.trim() === "";
    //     setCartItems((prevRows) => {
    //         const updatedRows = [...prevRows];
    //         console.log("updatedRows",updatedRows);
            
    //         lines.forEach((line, index) => {
    //             const tokens = line.trim().split(/\t+|\s{2,}/); // split by tab or 2+ spaces
    //             if (tokens.length < 2) {
    //                 toast.error(`Line ${index + 1}: Missing required fields`);
    //                 return;
    //             }
    //             const itemCode = tokens[0].trim();
    //             let quantity = 1; // default quantity
    //             let lastToken = tokens[tokens.length - 1].trim();
    //             let hasQuantity = /^\d+(\s+\w+)?$/.test(lastToken); // e.g., "3" or "3 Mtr"
    //             const itemNameTokens = hasQuantity ? tokens.slice(1, -1) : tokens.slice(1);
    //             const itemName = itemNameTokens.join(" ").trim();
    //             if (hasQuantity) {
    //                 quantity = lastToken;
    //             }
    //             if (isNullOrEmpty(itemCode) || isNullOrEmpty(itemName)) {
    //                 toast.error(`Line ${index + 1}: Missing item code or name`);
    //                 return;
    //             }
    
    //             const targetRow = rowIndex + index;
    //             if (!updatedRows[targetRow]) updatedRows[targetRow] = {};
    
    //             updatedRows[targetRow] = {
    //                 ...updatedRows[targetRow],
    //                 item_Code: itemCode,
    //                 item_Name: itemName,
    //                 quantity: quantity,
    //             };
    //         });
    
    //         if (updatedRows.length > 0) {
    //             const itemCodesFormatted = updatedRows
    //                 .filter(item => item.item_Code)
    //                 .map(item => `'${item.item_Code}'`)
    //                 .join(',');
    
    //             setCallInProgress(prev => ({ ...prev, getPasteItems: true }));
    //             dispatch(GetItembyPasting({ ItemCodes: itemCodesFormatted }));
    //         }
    
    //         return updatedRows;
    //     });
    // };
    // const handlePaste = (e, rowIndex) => {
    //     e.preventDefault();
    //     const paste = e.clipboardData.getData("text/plain");
    //     const lines = paste.trim().split(/\r?\n/);
    //     const isNullOrEmpty = (value) => !value || value.trim() === "";
    //     setCartItems((prevRows) => {
    //         const updatedRows = [...prevRows];
    //         const existingItemCodes = new Set(prevRows.map(row => row.item_Code));
    
    //         lines.forEach((line, index) => {
    //             const tokens = line.trim().split(/\t+|\s{2,}/); // split by tab or 2+ spaces
    //             if (tokens.length < 2) {
    //                 toast.error(`Line ${index + 1}: Missing required fields`);
    //                 return;
    //             }
    //             const itemCode = tokens[0].trim();
    //             let quantity = 1;
    //             const lastToken = tokens[tokens.length - 1].trim();
    //             // const hasQuantity = /^\d+(\s+\w+)?$/.test(lastToken);
    //             const hasQuantity = /^\d+$/.test(lastToken);
    //             const itemNameTokens = hasQuantity ? tokens.slice(1, -1) : tokens.slice(1);
    //             const itemName = itemNameTokens.join(" ").trim();
    //             if (hasQuantity) quantity = lastToken;
    
    //             if (isNullOrEmpty(itemCode) || isNullOrEmpty(itemName)) {
    //                 toast.error(`Line ${index + 1}: Missing item code or name`);
    //                 return;
    //             }
    
    //             if (existingItemCodes.has(itemCode)) {
    //                 toast.error(`Line ${index + 1}: Item code "${itemCode}" already exists`);
    //                 return;
    //             }
    
    //             const targetRow = rowIndex + index;
    //             if (!updatedRows[targetRow]) updatedRows[targetRow] = {};
    
    //             updatedRows[targetRow] = {
    //                 ...updatedRows[targetRow],
    //                 item_Code: itemCode,
    //                 item_Name: itemName,
    //                 quantity: quantity,
    //             };
    
    //             existingItemCodes.add(itemCode); // Add to prevent further duplicates in same paste
    //         });
    //         if (updatedRows.length > 0) {
    //             const itemCodesFormatted = updatedRows
    //                 .filter(item => item.item_Code)
    //                 .map(item => `'${item.item_Code}'`)
    //                 .join(',');
    
    //             setCallInProgress(prev => ({ ...prev, getPasteItems: true }));
    //             dispatch(GetItembyPasting({ ItemCodes: itemCodesFormatted }));
    //         }
    
    //         return updatedRows;
    //     });
    // };
    const handlePaste = (e, rowIndex) => {
        e.preventDefault();
        const paste = e.clipboardData.getData("text/plain");
        const lines = paste.trim().split(/\r?\n/);
        const isNullOrEmpty = (value) => !value || value.trim() === "";
        const errorMessages = new Set(); // Track unique error messages
        setCartItems((prevRows) => {
            const updatedRows = [...prevRows];
            const existingItemCodes = new Set(prevRows.map(row => row.item_Code));
            lines.forEach((line, index) => {
                const tokens = line.trim().split(/\t+|\s{2,}/); 
                if (tokens.length < 1) {
                    errorMessages.add("Missing required fields");
                    return;
                }
                const itemCode = tokens[0].trim();
                let quantity = '';
                const lastToken = tokens[tokens.length - 1].trim();
                const hasQuantity = /^\d+$/.test(lastToken);
                const itemNameTokens = hasQuantity ? tokens.slice(1, -1) : tokens.slice(1);
                const itemName = itemNameTokens.join(" ").trim();
                if (hasQuantity) quantity = lastToken;
    
                if (isNullOrEmpty(itemCode) || isNullOrEmpty(itemName)) {
                    // errorMessages.add("Missing item code or name");
                    return;
                }
                if (existingItemCodes.has(itemCode)) {
                    errorMessages.add(`Item code "${itemCode}" already exists`);
                    return;
                }
    
                const targetRow = rowIndex + index;
                if (!updatedRows[targetRow]) updatedRows[targetRow] = {};
    
                updatedRows[targetRow] = {
                    ...updatedRows[targetRow],
                    item_Code: itemCode,
                    item_Name: itemName,
                    quantity: quantity,
                };
    
                existingItemCodes.add(itemCode); // prevent duplicates in the same paste
            });
    
            if (updatedRows.length > 0) {
                const itemCodesFormatted = updatedRows
                    .filter(item => item.item_Code)
                    .map(item => `'${item.item_Code}'`)
                    .join(',');
    
                setCallInProgress(prev => ({ ...prev, getPasteItems: true }));
                dispatch(GetItembyPasting({ ItemCodes: itemCodesFormatted }));
            }
    
            return updatedRows;
        });
        if (errorMessages.size > 0) {
            errorMessages.forEach((msg) => {
                toast.error(msg);
            });
        }
    };
    
    const getColumnIndex = (column) => {
        const columnMapping = {
            item_Code: 0,
            item_Name: 1,
            quantity: 2,
            // Add other columns as needed
        };

        return columnMapping[column] || -1; // Default to -1 if not found
    };
    return (
        <div className='table-maindiv col-12 gap-5 ps-2 pe-1'>
            <div className='col-9 table-subdiv'>
                <div className="row-count-section">
                    <button className="Addrow-btn" onClick={handleAddRowClick}>Add Rows</button>
                    <div className="CheckDatePicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                // label={}
                                className="PRPicker"
                                value={DueDate}
                                minDate={dayjs()}
                                onChange={(newValue) => {
                                    if (newValue && dayjs.isDayjs(newValue)) {
                                        setDueDate(newValue);
                                    }
                                }}
                                format="DD/MM/YYYY"
                            />
                        </LocalizationProvider>
                    </div>
                </div>
                <div className="matrix table-container">
                    <table className="modular-table-design">
                        <thead className="modular-table-header">
                            <tr >
                                <th className='modular-header'>Action</th>
                                {columns.map((column, idx) => {
                                    if (!excludedColumns.includes(column)) {
                                        const columnPascal = convertColumnNameToPascalCase(column);
                                        // Convert once per column
                                        return (
                                            <th className='modular-header' key={idx}>
                                                {columnPascal}
                                            </th>
                                        );

                                    }

                                    return null;

                                })}

                            </tr>
                        </thead>
                        <tbody className="modular-table-body ">
                            {rows && rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td>
                                        <IconButton onClick={() => handleDeleteRow(rowIndex)} className="delete-button" size="small">
                                            <DeleteIcon />
                                        </IconButton>
                                    </td>
                                    {columns.map((column, colIndex) => {

                                        if (!excludedColumns.includes(column)) {
                                            const columnPascal = convertColumnNameToPascalCase(column); // Convert once per column
                                            return (

                                                <td className='alternate-color' key={colIndex}>
                                                    {/* For itemCode, itemName and Quantity columns */}
                                                    {column === 'item_Code' || column === 'item_Name' || column === 'quantity' ? (
                                                        <div className="dropdown-container h-100">
                                                            <input
                                                                // className='input-field'
                                                                className={`input-field ${searchTerms[rowIndex]?.[columnPascal] ? 'active-input' : ''} ${Object.entries(searchTerms[rowIndex] || {}).some(
                                                                    ([key, value]) => key !== columnPascal && value
                                                                ) ? 'disabled-input' : ''
                                                                    }`}
                                                                type="text"
                                                                value={
                                                                    (searchTerms[rowIndex]?.[columnPascal] || "") ||
                                                                    (cart[rowIndex]?.[column] || "") || ("")
                                                                }
                                                                onChange={(e) => {
                                                                    const value = e.target.value;

                                                                    if (column === 'quantity') {
                                                                        const itemCode = cart[rowIndex]?.item_Code || '';
                                                                        const itemName = cart[rowIndex]?.item_Name || '';
                                                                        if (!itemCode || !itemName) {
                                                                            toast.error('Select Item Code and Item Name before entering Quantity');
                                                                            return;
                                                                        }
                                                                        handleQuantityChange(e, rowIndex, column);
                                                                    } else {
                                                                        handleItemInputChange(value, 0, rowIndex, column); // ✅ pass full value, page = 0
                                                                    }
                                                                }}

                                                                onPaste={(e) => {
                                                                    const columnIndex = getColumnIndex(column); // Get column index dynamically based on column name
                                                                    handlePaste(e, rowIndex); // Pass to handlePaste
                                                                }}
                                                                placeholder={
                                                                    column === "quantity" &&
                                                                        (cart[rowIndex]?.quantity === "" ||
                                                                            cart[rowIndex]?.quantity === " " ||
                                                                            cart[rowIndex]?.quantity == null)
                                                                        ? "Enter quantity"  // Show 'Enter quantity' if quantity is empty or 0
                                                                        : `Search ${columnPascal}`  // Default search placeholder
                                                                }
                                                            />
                                                            {isDropdownOpen && searchResults.length >= 0 && searchTerms && searchTerms[rowIndex] && searchTerms[rowIndex][columnPascal] && (
                                                                <div
                                                                    className="click-blocker-overlay"
                                                                    onClick={(e) => e.stopPropagation()} // Prevent accidental propagation
                                                                />
                                                            )}
                                                            {searchTerms[rowIndex] && searchTerms[rowIndex][columnPascal] && searchItem && searchResults.length >= 0 && (
                                                                <div
                                                                    className="dropdown-list "
                                                                    ref={dropdownRef}
                                                                    onScroll={handleScroll}
                                                                >
                                                                    {loading.GetItmBySearch && <div className="loading-indicator">Loading...</div>}
                                                                    {!loading.GetItmBySearch && searchResults.length === 0 && (
                                                                        <div className="no-items">No items found</div>
                                                                    )}
                                                                    {Array.isArray(searchResults) && searchResults.length > 0 && searchResults.map((item, idx) => {
                                                                        const pascalItem = Object.keys(item).reduce((acc, key) => {
                                                                            const pascalKey = convertColumnNameToPascalCase(key);
                                                                            acc[pascalKey] = item[key];
                                                                            return acc;
                                                                        }, {});

                                                                        const itemCode = pascalItem["Item Code"] || "";
                                                                        const itemName = pascalItem["Item Name"] || "";
                                                                        const item_AlisName = pascalItem["Item AlisName"] || "";
                                                                        return (
                                                                            <div
                                                                                key={idx}
                                                                                className="dropdown-item "
                                                                                onClick={() => handleItemSelect(item, rowIndex, column)} // Select item
                                                                            >
                                                                                {itemCode} - {itemName}
                                                                            </div>
                                                                        );
                                                                    })}

                                                                </div>
                                                            )}
                                                        </div>
                                                    ) : column === 'Total' ? (
                                                        // Calculate and display Total (Quantity * Price)
                                                        <div className=''>
                                                            {cart[rowIndex]?.['total'] || ''}
                                                        </div>
                                                    ) : (
                                                        // For other columns, just display the value

                                                        <div className=''>
                                                            {row[column] || cart[rowIndex]?.[column]}</div>
                                                    )}
                                                </td>
                                            );
                                        }
                                        return null;
                                    })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    );
});

export default TableView;